import { useState } from 'react';
import './AuthPage.css';

interface AuthPageProps {
  onLogin: (username: string, password: string) => Promise<string | null>;
  onRegister: (username: string, password: string) => Promise<string | null>;
}

export function AuthPage({ onLogin, onRegister }: AuthPageProps) {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!username.trim() || !password || loading) return;

    if (mode === 'register') {
      if (password !== password2) {
        setError('两次密码不一致');
        return;
      }
      if (password.length < 6) {
        setError('密码至少 6 位');
        return;
      }
    }

    setLoading(true);
    setError('');

    const err = mode === 'login'
      ? await onLogin(username.trim(), password)
      : await onRegister(username.trim(), password);

    if (err) setError(err);
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">🦞</div>
        <h1 className="auth-title">
          {mode === 'login' ? '登录 Lobster' : '注册 Lobster'}
        </h1>
        <p className="auth-subtitle">
          {mode === 'login'
            ? '登录后连接你的电脑'
            : '创建账号，开始使用'}
        </p>

        {error && <div className="auth-error">{error}</div>}

        <input
          type="text"
          className="auth-input"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && document.getElementById('auth-pwd')?.focus()}
          placeholder="用户名"
          autoComplete="username"
          autoFocus
        />
        <input
          id="auth-pwd"
          type="password"
          className="auth-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              if (mode === 'register') document.getElementById('auth-pwd2')?.focus();
              else handleSubmit();
            }
          }}
          placeholder="密码"
          autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
        />
        {mode === 'register' && (
          <input
            id="auth-pwd2"
            type="password"
            className="auth-input"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            placeholder="确认密码"
            autoComplete="new-password"
          />
        )}

        <button
          className="auth-button"
          onClick={handleSubmit}
          disabled={loading || !username.trim() || !password}
        >
          {loading ? '请稍候...' : mode === 'login' ? '登录' : '注册'}
        </button>

        <div
          className="auth-switch"
          onClick={() => {
            setMode(mode === 'login' ? 'register' : 'login');
            setError('');
          }}
        >
          {mode === 'login' ? '没有账号？注册' : '已有账号？登录'}
        </div>
      </div>
    </div>
  );
}
